import script from "./DashViewNew.vue?vue&type=script&setup=true&lang=js"
export * from "./DashViewNew.vue?vue&type=script&setup=true&lang=js"

import "./DashViewNew.vue?vue&type=style&index=0&id=4914a81a&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4914a81a"]])

export default __exports__